import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function AccountHolder({ accountHolder, title = 'Account holder' }) {
  if (!accountHolder) {
    return null;
  }

  return (
    <Grid
      item
      md={4}
      xs={12}
    >
      <Stack
        direction="column"
        gap="8px"
      >
        <Text
          color="tertiary"
          size="xs"
          uppercase
        >
          {title}
        </Text>
        <Text size="lg">{accountHolder}</Text>
      </Stack>
    </Grid>
  );
}

AccountHolder.propTypes = {
  accountHolder: PropTypes.string,
  title: PropTypes.string
};
